import { type MessageDescriptor } from 'react-intl';

import { type MessageTemplateContext } from '../index';

type ButtonBase = {
	actionSubject: string;
	message: MessageDescriptor;
	appearance: 'primary' | 'subtle';
	id: string;
	testId: string;
	analyticAttributes: Record<string, unknown>;
};

export type TakeTourButton = ButtonBase & {
	action: 'takeTour';
};

export type DismissButton = ButtonBase & {
	action: 'dismiss';
};

export type LinkButton = ButtonBase & {
	action: 'link';
	href: string;
};

export type Content = {
	title: MessageDescriptor;
	description: MessageDescriptor;
	features: {
		icon: React.ReactNode;
		message: MessageDescriptor;
	}[];
	buttons: (DismissButton | TakeTourButton | LinkButton)[];
};

export enum SpotlightTourMode {
	DISABLED = 0,
	EXCLUDE_ROVO = 2,
	SHOW_ALL = 3,
}

export type Variant = MessageTemplateContext['variant'];

export type ContentConfig = Record<Exclude<Variant, 'none'>, Content>;

export type Button = Content['buttons'][number];
